import React from "react";
import Stat from "./Stat";
import { money, riderCount } from "./settlementParts";

export default function EnrollStats({ sheet, rows }) {
  const submittedCount = rows.filter((r) => r.statement).length;
  return (
    <section className="stl-stats">
      <Stat label="Orders" value={sheet.totals.orders} hint={`by ${riderCount(rows.length)}`} />
      <Stat label="Salaries submitted" value={`${submittedCount} / ${rows.length}`}>
        <span className="stl-progress">
          <span style={{ width: `${(submittedCount / rows.length) * 100}%` }} />
        </span>
      </Stat>
      <Stat label="Cash in hand" value={money(sheet.totals.collection)} hint="held by riders now" />
      <Stat label="Charges owed" value={money(sheet.totals.earnings)} hint="owed to riders now" />
    </section>
  );
}
